import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  EmbeddedViewRef,
  EventEmitter,
  Inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { ValDropDownComponent } from './val-drop-down.component';

@Directive({
  selector: '[valDropDown],[valddVisible],[valddVisibleChange],[valddClass],[valddDisabled]'
})

export class ValDropDownDirective implements OnDestroy, AfterViewInit, OnInit {
  private _closeSub: Subscription;
  private _loaded = false;
  private _visible = false;
  private _btnref: HTMLElement;
  private _componentRef: ComponentRef<ValDropDownComponent>;
  public viewRef: EmbeddedViewRef<any>;
  private _class: string;
  @Input('valDropDown') set btnref(x: HTMLElement) {
    this._btnref = x;
    this._btnref.onclick = this.toggle;
  }
  @Input('valddVisible') set visible(x: boolean) {
    if (this._loaded && (this._visible != x)) {
      this.toggle();
    }
  }
  @Input('valddClass') set class(x: string) {
    this._class = x;
  }
  @Input('valddDisabled') disabled = false;
  @Output('valddVisibleChange') visibleChange = new EventEmitter<boolean>();
  constructor(
    private _templateRef: TemplateRef<any>,
    private _appRef: ApplicationRef,
    private _injector: Injector,
    private _componentFactoryResolver: ComponentFactoryResolver,
    @Inject(DOCUMENT) private _document: Document,
  ) {
  }
  private _loadComponent = (): ComponentRef<ValDropDownComponent> => {
    let componentRef: ComponentRef<ValDropDownComponent>;
    this._unloadComponent();

    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(ValDropDownComponent);
    componentRef = componentFactory.create(this._injector);
    componentRef.instance.btn = this._btnref;
    componentRef.instance.class = this._class;

    this._appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    this._document.body.appendChild(domElem);
    return componentRef;
  }
  private _loadTemplate = () => {
    this._componentRef.instance.vc.createEmbeddedView(this._templateRef);
  }
  private _unloadComponent = () => {
    if (this._componentRef) {
      this._appRef.detachView(this._componentRef.hostView);
      this._componentRef.destroy();
      this._componentRef = null;
    }
  }

  private _closeDropDown = () => {
    if (this._closeSub) {
      this._closeSub.unsubscribe();
    }
    this._unloadComponent();
  }

  private _showDropDown = () => {
    this._componentRef = this._loadComponent();
    if (!this._componentRef) { return; }
    this._loadTemplate();
    this._closeSub = this._componentRef.instance.close.subscribe((x) => {
      this._closeDropDown();
      this._visible = false;
      this.visibleChange.emit(this._visible);
    });
    this._componentRef.changeDetectorRef.detectChanges();
  }
  ngOnDestroy(): void {
    if (this._visible) {
      this._closeDropDown();
    }
  }

  ngOnInit(): void {
    this._loaded = false;
  }

  ngAfterViewInit(): void {
    this._loaded = true;
  }

  public toggle = (e: any = null) => {
    this._visible = this.disabled ? false : !this._visible;
    if (this._loaded) {
      if (this._visible) {
        this._showDropDown();
      } else {
        if (this._componentRef && this._componentRef.instance) {
          this._componentRef.instance.animationState = "hidden";
        }
      }
      this.visibleChange.emit(this._visible);
    }
  }
}
